import {Component, OnInit, Input, OnChanges} from '@angular/core';
import {
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
  FormArray,
  FormGroup,
  FormControl
} from '@angular/forms';
import {FileUploader, ParsedResponseHeaders, FileItem, FileUploadModule} from 'ng2-file-upload';
import {WizardWidgetComponent} from '../wizard-widget/wizard-widget.component';
import {
  TypesService,
  ApplicationService,
  FormBuilderService,
  NotificationService,
  FileService
} from '../../../services';
import {environment} from '../../../../environments/environment';
import {IndividualDocumentModel} from '../../../models/widgets/documents-upload-model';
import {OAuthService} from 'angular-oauth2-oidc';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatChipsModule} from '@angular/material/chips';
import {MatInputModule} from '@angular/material/input';
import {MatOptionModule} from '@angular/material/core';
import {NgFor, NgIf, NgClass} from '@angular/common';
import {MatSelectModule} from '@angular/material/select';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatCardModule} from '@angular/material/card';
import {DataHandlerService} from '../../../services/data-handler.service';
import * as _ from 'lodash';
import * as uuid from 'uuid';

const COMPANY = 'company';
const PERSON = 'person';
const TRUST = 'trust';
const APPLICATION = {id: 1, text: 'application'};
const APPLICANT = {id: 2, text: 'applicant'};
const SECURITY = {id: 3, text: 'security'};

@Component({
  selector: 'app-docs-upload',
  templateUrl: './documents-upload.component.html',
  styles: [],
  standalone: true,
  imports: [MatCardModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatFormFieldModule,
    MatSelectModule, NgFor, MatOptionModule, MatInputModule, NgIf, MatChipsModule, MatIconModule,
    FileUploadModule, NgClass, MatButtonModule]
})

export class DocumentUploadComponent extends WizardWidgetComponent implements OnInit, OnChanges {
  @Input() public formGroup: any;
  @Input() public isHomeLoan: any;
  @Input() public personList: any;
  @Input() public companyList: any;
  @Input() public trustList: any;
  @Input() public securityDetails: any;
  @Input() public step: any;
  @Input() public activeStep: any;

  public uploader: FileUploader;
  public documentTypeSlug = 'document-types';
  public documentTypeCategorySlug = 'document-categories';
  public getDocTypesParameter = 'vx';
  public documentCategoryID = 1;
  private uploadUrl = environment.api.submission + '/files';
  public maxFileSizeMb = 50; // Set it to 50 by default

  public securityList: any = [];
  public partyList: any = [];
  public uploadData: any = [];
  public selectedDocType: any;
  public allDocTypes = [];
  public filesList = [];
  public showUploader = false;
  public showFileList = false;
  public loading = false;
  public hasDropZoneOver = false;
  public showSecurities = false;
  public showParties = false;
  public documentArray: any;

  public ommittedHomeLoanDocTypes: any = [
    'insaxaq',
    'dti',
    'dd',
    'emp',
    'mia',
    'mip',
    'motcos',
    'motinv',
    'pof',
    'pslip',
  ];

  constructor(public filesService: FileService,
              private formBuilderService: FormBuilderService,
              private oauthService: OAuthService,
              private notificationService: NotificationService,
              private applicationService: ApplicationService,
              public dataHandlerService: DataHandlerService) {
    super(dataHandlerService);
  }

  ngOnInit() {
    super.ngOnInit();

    this.populateDocTypes();
    this.resetUpload();
    this.initUploader();
    this.checkPacketIdentities();
  }

  ngOnChanges(changes) {
    this.documentArray = this.formGroup.get('files');

    if (changes.activeStep && changes.activeStep.currentValue && changes.activeStep.previousValue !== changes.activeStep.currentValue) {
      this.checkPacketIdentities();
    }

    if (changes['formGroup'] && changes['formGroup']['firstChange']) {
      if (this.documentArray.value.length > 0) {
        this.showFileList = true;
      }
    }
  }


  checkPacketIdentities() {
    const persons = (this.personList && this.personList.value.length > 0) ?
      this.personList.value.map((value, index) => {
        const person: any = {};
        person.name = `${value.firstName || ''} ${value.middleName ? `${value.middleName} ` : ''}${value.lastName || ''}`;
        person.id = `${PERSON}-${index}`;
        return person;
      }) : [];

    const trusts = (this.trustList && this.trustList.value.length > 0) ?
      this.trustList.value.map((value, index) => {
        const trust: any = {};
        trust.name = value.trustName;
        trust.id = `${TRUST}-${index}`;
        return trust;
      }) : [];

    const companies = (this.companyList && this.trustList.value.length > 0) ?
      this.companyList.value.map((value, index) => {
        const company: any = {};
        company.name = value.companyName;
        company.id = `${COMPANY}-${index}`;
        return company;
      }) : [];

    this.partyList = persons.concat(trusts, companies);

    if (this.securityDetails && this.securityDetails.length > 0 && this.isHomeLoan) {
      this.securityList = this.securityDetails.map((value, index) => {
        const security: any = {};
        security.name = (value.securityAddress) ? value.securityAddress.flatSearch : 'TBA';
        security.id = `collateral-${index}`;
        return security;
      });
    } else if (!this.isHomeLoan) {
      this.dataHandlerService.getSecuredAsset()
        .subscribe((result: any) => {
          if (result && result.vehicle && result.vehicle.description) {
            this.securityList = [{
              name: result.vehicle.description,
              id: 'collateral-0'
            }];
          }
        });
    }

    console.log('checkPacketIdentities', JSON.stringify(this.formGroup.getRawValue(), null, 2));
  }

  public populateDocTypes() {
    this.filesService.getDocumentTypesWithJobType().subscribe((results) => {
      const documentTypes = results || [];
      this.allDocTypes = _.sortBy(documentTypes, ['text']) || [];

      // if product category home-loan remove docTypes in this list ommittedHomeLoanDocTypes
      if (this.isHomeLoan) {
        this.allDocTypes = _.filter(this.allDocTypes, doctype => !this.ommittedHomeLoanDocTypes.includes(doctype.id));
      }
    });
  }

  public initUploader() {
    this.uploader = new FileUploader({
      url: `${this.uploadUrl}`,
      authToken: `Bearer ${this.oauthService.getAccessToken()}`,
    });

    this.uploader.onBuildItemForm = (item, form) => {
    };

    this.uploader.onAfterAddingFile = (item: FileItem) => {

      try {
        const fileSize = item.file.size / 1024 / 1024; // MB
        if (fileSize > this.maxFileSizeMb) {
          console.log('[uploader]', '[ERROR]', 'Max file size exceeded.');
          this.notificationService.toast('warn', `Exceed the ${this.maxFileSizeMb} MB file size limit.`);
          return;
        }
      } catch (e) {
        console.log('[uploader]', '[ERROR]', e);
      }
      this.uploader.uploadItem(item);
    };

    this.uploader.onBeforeUploadItem = (item: FileItem) => {
      const docType = this.selectedDocType.id;
      const comments = this.formGroup.value.comments;
      const name = item.file.name;
      this.uploader.options.url = this.uploadUrl + '/' + encodeURI(name);
      this.loading = true;
      const headers: any = [
        {
          name: 'x-fmc-file-type',
          value: docType
        },
        {
          name: 'x-fmc-file-comment',
          value: comments
        },
      ];
      this.uploader.setOptions({
        url: this.uploadUrl + '/' + encodeURI(name),
        headers
      });
    };

    this.uploader.onCompleteItem = (item: FileItem, response: string, status: number, headers: ParsedResponseHeaders) => {
      let uploadData: any;

      try {
        uploadData = JSON.parse(response);
        if (uploadData && typeof uploadData === 'object' && uploadData.code === 'ServiceUnavailable') {
          this.notificationService.toast('warn', 'Error uploading file. Please try again later.');
          return;
        }
        const data = {
          key: uploadData,
          origName: item.file.name,
        };

        data['description'] = this.selectedDocType.text;
        data['documentTypeCode'] = this.selectedDocType.id;
        data['party'] = null;
        data['security'] = null;
        this.uploadData.push(data);
      } catch (e) {
        console.log('[onCompleteItem]', '[ERROR]', e);
      }
    };

    this.uploader.onCompleteAll = () => {
      this.loading = false;
      this.uploader.clearQueue();
      this.setFormError();
    };

    this.uploader.onErrorItem = (item: FileItem, response: string, status: number, headers: ParsedResponseHeaders) => {
      this.loading = false;
      console.error('Error during file upload', response);
      this.notificationService.toast('warn', 'Error uploading file. Please try again later.');
    };
  }

  public setFormError() {
    if (this.uploadData.length) {
      this.formGroup.setErrors({upload: true});
    } else {
      this.formGroup.setErrors(null);
    }
  }

  public addFileToList(formGroup: any) {
    this.formGroup.updateValueAndValidity();
    console.log('DocumentUploadComponent:::this.formGroup', this.formGroup);
    if (this.formGroup.invalid) {
      console.log('this.formGroup rawValue', this.formGroup.getRawValue());
      this.notificationService.toast('warning', 'Error adding file to list of documents');
      return;
    }

    if (this.uploadData) {
      this.addFile();

      formGroup.get('securities').clearValidators();
      formGroup.get('securities').updateValueAndValidity();

      formGroup.get('parties').clearValidators();
      formGroup.get('parties').updateValueAndValidity();
    }
    this.setFormError();
  }

  public resetUpload() {
    this.selectedDocType = null;
    this.formGroup.get('parties').patchValue(null);
    this.formGroup.get('securities').patchValue(null);
    this.formGroup.get('documentType').patchValue('');
    this.formGroup.get('comments').patchValue('');
    this.showUploader = false;
    this.showSecurities = false;
    this.showParties = false;
    this.setFormError();
  }

  public fileOverBase(event) {
    this.hasDropZoneOver = event;
  }

  public updateSelectedDocType(id: any) {
    this.showUploader = true;
    const foundType: any = _.find(this.allDocTypes, doctype => _.lowerCase(doctype.id) === _.lowerCase(id));
    this.selectedDocType = (foundType) ? foundType : null;

    this.formGroup.removeControl('parties');
    this.formGroup.addControl('parties', new FormControl(null, Validators.compose([])));

    this.formGroup.removeControl('securities');
    this.formGroup.addControl('securities', new FormControl(null, Validators.compose([])));

    console.log('selectedDocType', this.selectedDocType);

    if (_.has(foundType, 'ext.entityType')) {
      const entityType = foundType.ext.entityType;
      this.showSecurities = (entityType && entityType === SECURITY.text);
      this.showParties = (entityType && entityType === APPLICANT.text);

      if (this.showParties) {
        // this.checkDocumentRules(foundType, this.formGroup, 'parties');
        this.formGroup.get('parties').setValidators(Validators.required);
        this.formGroup.get('parties').markAsTouched();
        this.formGroup.get('parties').updateValueAndValidity();

        this.formGroup.get('securities').clearValidators();
        this.formGroup.get('securities').updateValueAndValidity();
      }

      if (this.showSecurities) {
        // this.checkDocumentRules(foundType, this.formGroup, 'securities');
        this.formGroup.get('securities').setValidators(Validators.required);
        this.formGroup.get('securities').markAsTouched();
        this.formGroup.get('securities').updateValueAndValidity();

        this.formGroup.get('parties').clearValidators();
        this.formGroup.get('parties').updateValueAndValidity();
      }
    } else {
      this.formGroup.get('parties').clearValidators();
      this.formGroup.get('parties').updateValueAndValidity();

      this.formGroup.get('securities').clearValidators();
      this.formGroup.get('securities').updateValueAndValidity();

      this.showSecurities = false;
      this.showParties = false;
    }
  }

  public deleteTempDoc(index) {
    this.uploadData.splice(index, 1);
    this.setFormError();
  }

  /**
   * Revalidates the document rules after a file is removed
   * @param documentType
   */
  revalidateDocumentRules(documentType: any) {
    const documentVault = _.get(documentType, 'system.documentVault', null);

    if (documentVault) {
      const uploadConfig = documentVault.upload;
      if (uploadConfig && uploadConfig.multiple && typeof uploadConfig.limit === 'number') {
        let currentDocumentFilesCount = 0;

        this.documentArray.controls.forEach((formGroup: FormGroup) => {
          if (formGroup.get('documentType').value === documentType) {
            currentDocumentFilesCount++;
          }
        });

        this.documentArray.controls.forEach((formGroup: FormGroup) => {
          if (formGroup.get('documentCode').value === documentType) {
            if (currentDocumentFilesCount > uploadConfig.limit) {
              formGroup.get('documentCode').setErrors({uploadLimitExceeded: true});
            } else {
              formGroup.get('documentCode').setErrors(null);
            }
          }
        });
      }
    }
  }

  // chip actions
  public deleteDoc(index) {
    const data = this.documentArray.at(index).value;
    if (data && data.checksum) {
      this.applicationService.deleteAttachment(data)
        .subscribe({
          next: (result: any) => {
            const documentType: any = this.documentArray.at(index).get('documentType').value;
            this.documentArray.removeAt(index);
            if (this.documentArray.value.length < 1) {
              this.showFileList = false;
            }
            this.revalidateDocumentRules(documentType);
          },
          error: (error: any) => {
            console.log('deleteDoc error', error);
          }
        });
      // });
    } else {
      this.documentArray.removeAt(index);
    }
  }

  public addFile() {
    console.log('addFile', this.formGroup);
    const tempUploadData: any = this.uploadData;
    const uploadLink = uuid.v4();

    tempUploadData.forEach((file: any) => {
      file.comments = this.formGroup.get('comments').value;
      file.description = this.selectedDocType.text;
      file.documentTypeCode = this.selectedDocType.id;
      file.uploadLink = uploadLink;

      if (this.formGroup.get('parties').value) {
        const party: string = this.formGroup.get('parties').value;
        file['party'] = party;

        const relatedDocument = this.checkExistingDocuments('party', party);
        console.log('relatedDocument', relatedDocument);

        if (relatedDocument) {
          file.uploadLink = relatedDocument.uploadLink;
        }

        this.addToDocumentArray(file);
      } else if (this.formGroup.get('securities').value) {
        const security: string = this.formGroup.get('securities').value;
        file['security'] = security;

        const relatedDocument = this.checkExistingDocuments('security', security);
        console.log('relatedDocument', relatedDocument);

        if (relatedDocument) {
          file.uploadLink = relatedDocument.uploadLink;
        }

        this.addToDocumentArray(file);
      } else {
        this.addToDocumentArray(file);
      }
    });

    this.resetUpload();
    this.uploadData = [];
  }

  /**
   * Checks if the existing entity already has documents preloaded on the same docType
   * @param entityType
   * @param entityValue
   */
  checkExistingDocuments(entityType: string, entityValue: string) {
    console.log('documentArray', this.documentArray);
    const documentArrayValues: any = this.documentArray.getRawValue();
    return documentArrayValues.find((x: any) => x[entityType] === entityValue && x.documentTypeCode === this.selectedDocType.id);
  }

  addToDocumentArray(file: any) {
    const fg = this.formBuilderService.convertObjectToFormGroup(new IndividualDocumentModel());
    fg.setValue(file);
    this.formBuilderService.setValidationRules(new IndividualDocumentModel(), fg);
    this.documentArray.push(fg);

    console.log('this.documentArray', this.documentArray, file);
  }
}
